import { createContext, useContext, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { useLocalStorage } from "./useLocalStorage";
import Cookies from 'js-cookie';
import { redirect } from "react-router-dom";
const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useLocalStorage("user", null);
  const [postLoginRedirect, setPostLoginRedirect] = useLocalStorage("postLoginRedirect", "/workspaces");
  const navigate = useNavigate();

  // call this function when you want to authenticate the user
  const login = async (data) => {
    // setUser(data);
    Cookies.set('trivia_token', data, { expires: 30000, secure: true });
    const path = postLoginRedirect || "/workspaces";
    setPostLoginRedirect("/workspaces"); // reset after use

    navigate(path);
  };

  // call this function to sign out logged in user
  const logout = () => {
    // setUser(null);
    Cookies.remove('trivia_token');
  };

  const value = useMemo(
    () => ({
      user,
      login,
      logout,
      setPostLoginRedirect
    }),
    [user, setPostLoginRedirect]
  );
  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export const useAuth = () => {
  return useContext(AuthContext);
};

export const checkIfLoggedIn = async ({ request }) => {
  const token = Cookies.get('trivia_token');

  if (!token) {
    const requestedUrl = new URL(request.url).pathname;
    localStorage.setItem('postLoginRedirect', requestedUrl);
    return redirect('/login');
  }

  return null;
};

export const checkIfLoggedOut = () => {
  const token = Cookies.get('trivia_token');

  if (token) {
    return redirect("/workspaces");
  }

  return null;
};